<template>
    <div class="row mt-4">
        <div class="col-md-6 col-sm-3 col-xs-6">
            <div class="frameTitle">{{$t('product.properties.compositions.title')}}</div>
            <div class="frameContent">
                <template v-for="composition in product.compositions">
                  <span :key="composition.id">
                    {{ composition.part }} % {{composition.title}}
                    <br>
                  </span>
                </template>
            </div>
        </div>
        <div class="col-md-6 col-sm-3 col-xs-6">
            <div class="frameTitle">{{$t('product.properties.info.title')}}</div>
            <div class="frameContent">
                <table class="w-100">
                    <colgroup>
                        <col width='1px' />
                        <col />
                    </colgroup>
                    <tr v-if="product.width > 0">
                        <td><b>{{$t('product.properties.info.width')}}:</b></td>
                        <td>{{ product.width }} cm</td>
                    </tr>
                    <tr v-if="product.step > 0.1 && product.unit == 'm'">
                        <td><b>{{$t('product.properties.info.raport')}}:</b></td>
                        <td>{{ product.step * 100 }} cm</td>
                    </tr>
                    <tr v-if="product.weight">
                        <td><b>{{$t('product.properties.info.weight')}}:</b></td>
                        <td>{{ product.weight }} g/m2</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: ['product']
}
</script>
